import { render, staticRenderFns } from "./TransloadAndDeliver.vue?vue&type=template&id=19d0dd66&scoped=true"
import script from "./TransloadAndDeliver.vue?vue&type=script&lang=js"
export * from "./TransloadAndDeliver.vue?vue&type=script&lang=js"
import style0 from "./TransloadAndDeliver.vue?vue&type=style&index=0&id=19d0dd66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d0dd66",
  null
  
)

export default component.exports